import React from "react";
import {CHILE} from "../../../../constants"
import {
  AppBar,
  Container,
  Grid,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { FooterJss } from './styleJss';


const Footer = ({country}) => {
  const ripleyCL = "Comercial ECCSA S.A., Rut N° 83.382.700-6, domiciliada en Avenida Cerro Colorado 5240, Torre del Parque 1 Piso 11, comuna Las Condes, Santiago de Chile."
  const ripleyPE = "TIENDAS POR DEPARTAMENTO RIPLEY S.A.C., Ruc N° 20337564373, Calle Las Begonias N° 545, piso 10, Distrito de San Isidro. Lima Perú "
  const aboutRipley = country === CHILE.value ? ripleyCL : ripleyPE
  const classes = FooterJss();
  return (
    <Grid container item>
      <AppBar position="static" elevation={0} className={classes.appBar}>
        <Toolbar className={classes.footerToolbar}>
          <Container maxWidth="md">
            <Typography variant="body1" align="center" className={classes.footerTextPrimary}>
              Seguridad y Privacidad Garantizada SSL Secure GlobalSign. Comprar en Ripley.com es 100% seguro.
            </Typography>
            <Typography variant="body2" align="center" className={classes.footerText}>
            {aboutRipley}
            </Typography>
            <Typography variant="body2" align="center" className={classes.footerText}>
              Precios publicados aplican exclusivamente a Internet y
              Venta Telefónica, estos pueden llegar a ser distintos en tiendas.
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
    </Grid>
  )
}

export default Footer